import { InjectionToken } from '@angular/core';
import { IsAuthzAppUserPredicate } from '@mri/angular-wfe-proxy-oidc';

export const IS_AUTHZ_APP_USER_PREDICATE = new InjectionToken<IsAuthzAppUserPredicate>(
  'getIsAuthorizedAppUser Injection Token'
);
